import { alpha, styled } from '@mui/material/styles';
import { Column } from 'global/components/row';

export const StyledRatingRow = styled('div', {
  shouldForwardProp: (prop) => prop !== 'textSmall',
})(({ textSmall }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  ...(textSmall ? { fontSize: 12 } : {}),
}));

export const StyledCol = styled('div', {
  shouldForwardProp: (prop) => !['isMobile', 'textSmall'].includes(prop),
})(({ theme, isMobile, textSmall }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'row' : 'column',
  flex: '1 1 auto',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  ...(textSmall ? { fontSize: 12 } : {}),
}));

export const StyledRatingWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  width: '100%',
}));

export const StyledColMobile = styled('div', {
  shouldForwardProp: (prop) => prop !== 'maxWidth',
})(({ maxWidth }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  height: '100%',
  width: 45,
  minHeight: 30,
  alignItems: 'left',
  justifyContent: 'center',
  textAlign: 'left',
  ...(maxWidth
    ? {
        maxWidth: 20,
        minWidth: 20,
        alignItems: 'center',
        textAlign: 'center',
      }
    : {}),
}));

export const StyledTextCol = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const StyledCpRow = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hlRow',
})(({ theme, hlRow }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  pageBreakInside: 'avoid !important',
  ...(hlRow ? { backgroundColor: alpha(theme.palette.error.main, 0.15) } : {}),
}));

export const StyledCpName = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  width: isMobile ? 100 : `calc(160px - ${theme.spacing(2)})`,
  minWidth: isMobile ? 100 : `calc(160px - ${theme.spacing(2)})`,
  fontWeight: 600,
  fontSize: 12,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1),
}));

export const StyledCpColumn = styled(Column, {
  shouldForwardProp: (prop) => prop !== 'cpBg',
})(({ theme, cpBg }) => ({
  ...(cpBg === 0 ? { backgroundColor: theme.palette.action.disabledBackground } : {}),
}));
